var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Router, NavigationEnd } from '@angular/router';
import { OnInit, OnDestroy } from '@angular/core';
import { PreRenderService } from '../../services/pre-render.service';
import { HasSubscriptions } from '../../components/has-subscriptions';
import { RoutingHistoryService } from '../../services/routing-history.service';
import { HistoryItem } from '../../classes/history-item';
import { MetaTagService } from '../../services/meta-tag.service';
var PageNotFoundComponent = /** @class */ (function (_super) {
    __extends(PageNotFoundComponent, _super);
    function PageNotFoundComponent(prerenderService, router, historyService, metaTagsService) {
        var _this = _super.call(this) || this;
        _this.prerenderService = prerenderService;
        _this.router = router;
        _this.historyService = historyService;
        _this.metaTagsService = metaTagsService;
        _this._destroyed = false;
        return _this;
    }
    PageNotFoundComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.prerenderService.setPreRenderFlag(404);
        // This is needed to detect that the url changed but we ended up on 404 page again.
        if (this.prerenderService.isServerMode) {
            this.addSub(this.router.events.subscribe(function (e) {
                if (e instanceof NavigationEnd && !_this._destroyed) {
                    _this.prerenderService.setPreRenderFlag(404);
                }
            }));
        }
        this.historyService.push(new HistoryItem());
        this.metaTagsService.setPageTitle('meta-tags.page-not-found.title', {});
    };
    PageNotFoundComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this._destroyed = true;
        this.historyService.pop();
    };
    return PageNotFoundComponent;
}(HasSubscriptions));
export { PageNotFoundComponent };
